<template>
  <div class="modal modal-open">
    <div class="modal-box">
      <h2 class="text-2xl font-bold">
        {{ isEdit ? 'Update' : 'Create' }} Video
      </h2>
      <div class="form-control">
        <label class="label"><span class="label-text">Title</span></label>
        <input
          v-model="videoData.title"
          placeholder="Guy Likes Wieners"
          class="input input-bordered"
        />
      </div>
      <div class="form-control">
        <label class="label"><span class="label-text">Url</span></label>
        <input
          v-model="videoData.url"
          placeholder="https://www.youtube.com/embed/VIDEO_ID"
          class="input input-bordered"
        />
      </div>
      <div class="form-control">
        <label class="label"><span class="label-text">Thumbnail</span></label>
        <input
          v-model="videoData.thumbnail"
          placeholder="https://i3.ytimg.com/vi/VIDEO_ID/maxresdefault.jpg"
          class="input input-bordered"
        />
      </div>
      <div class="form-control">
        <label class="label cursor-pointer"
          ><span class="label-text">Visible</span>
          <input v-model="videoData.visible" type="checkbox" class="checkbox"
        /></label>
      </div>
      <div class="modal-action">
        <button class="btn btn-ghost" @click="$emit('close')">Cancel</button>
        <button class="btn btn-primary" :disabled="!canSave" @click="save">
          {{ isEdit ? 'Update' : 'Create' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, toRefs, watch } from 'vue'
import { videosCollection } from '../firebase'
import { addDoc, doc, updateDoc } from 'firebase/firestore'

const props = defineProps({
  video: {
    type: Object,
    default: () => ({
      title: '',
      url: '',
      thumbnail: 'https://i3.ytimg.com/vi/VIDEO_ID/maxresdefault.jpg',
      visible: true,
    }),
  },
  isEdit: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'save-success', 'save-error'])

const { video, isEdit } = toRefs(props)
const videoData = ref({})

watch(
  video,
  (newVideo) => {
    videoData.value = { ...newVideo }
  },
  { immediate: true, deep: true }
)

const canSave = computed(
  () =>
    videoData.value.title && videoData.value.url && videoData.value.thumbnail
)

const save = async () => {
  try {
    if (isEdit.value) {
      const docRef = doc(videosCollection, videoData.value.id)
      await updateDoc(docRef, videoData.value)
    } else {
      await addDoc(videosCollection, {
        ...videoData.value,
        dateCreated: new Date(),
      })
    }
    emit('save-success', 'Successfully Saved Video')
    emit('close')
  } catch (error) {
    console.error('Failed to save video:', error)
    emit('save-error', 'Failed to save video.')
  }
}
</script>
